import { Modal } from "react-bootstrap";
import { t } from "i18next";

const ErrorModal = ({ show, message, onClose, enrollLink, isGetStarted, isOkay, isBehavioralHealthSelected, isCancellationSelected ,isPendedStatusSelected,showConfirmButtons,showNurseFavorite,isEggFreezing, onOkay, showEmailPhoneOptions, maskedEmail, maskedPhone, onEmailClick, onPhoneClick,onYes, onNo, onContinue, title, showCall, closeButton}) => {
  const handleCall988 = async() => {
    await onClose();
    window.location.href = "tel:988"
  }
  return (
    <Modal show={show} onHide={onClose} centered className="custom-modal" shouldCloseOnOverlayClick={false}>
      {closeButton && (<Modal.Header className="model-header" closeButton onHide={onClose}></Modal.Header>)}
      <Modal.Body className="text-center">
        { onContinue ? (
          <div>
          <p className="modal-message">{title}</p>
          <p className="modal-message-subtext">{message}</p>
          </div>
         ) : 
        <p className="modal-message">{message}</p>
}
         {/* Conditional buttons based on whether enrollLink is provided */}
         {enrollLink ? (
          <div className="d-flex justify-content-around">
            <button onClick={onClose} className="win-model-btn-tertiary">
              {t("Cancel")}
            </button>
            <button
              onClick={() => window.open(enrollLink, "_blank")}
              className="win-model-btn-primary"
            >
              {t("clicktoenroll")}
              </button>            
          </div>
          ): onContinue ? (
          <div className="d-flex justify-content-around">
            {!closeButton && <button onClick={onClose} className="win-model-btn-primary">
            {t("Cancel")}
         </button>}
          <button onClick={onOkay} className="win-model-btn-primary">
            {t("Continue")}
          </button>
         </div>
        ) : isGetStarted ? (
            <button onClick={onOkay} className="win-model-btn-primary">
              {t("getstarted")}
            </button>
          ) : isOkay ? (
            <button onClick={onOkay} className="win-model-btn-primary">
              {t("okay")}
            </button>
          ) : showNurseFavorite ? (
            <div className="d-flex justify-content-around">
              <button onClick={onClose} className="win-btn-secondary-w-content highmark-option-no-border">
                No, Cancel
                </button>
                <button
                  onClick={onOkay}
                  className="win-model-btn-primary"
                >
                  Yes, I'm Sure
                </button>            
              </div>
          ) : onOkay && onClose ? (
          <div className="d-flex justify-content-around">
            <button onClick={showCall ? handleCall988 : onClose} className="win-btn-secondary-w-content highmark-option-no-border">
              {showCall? t("Call (988)") : t("Cancel")}
            </button>
            <button onClick={onOkay} className="win-model-btn-primary">
              {t("okay")}
            </button>
          </div>
        ) :showEmailPhoneOptions ? (
          <div>
            <div className="mb-4">{/* Main custom message block */}</div>
            <div className="d-flex justify-content-around">
              <button className="win-model-btn-tertiary" onClick={onEmailClick}>Email</button>
              <button className="win-model-btn-primary" onClick={onPhoneClick}>Phone</button>
            </div>
          </div>
        )
          : isBehavioralHealthSelected ? (
            <div className="d-flex justify-content-around">
              <button onClick={onClose} className="win-model-btn-tertiary">
                {t("Cancel")}
              </button>
              <button
                onClick={onOkay}
                className="win-model-btn-primary"
              >
                 {t("ok")}
              </button>            
            </div>
            ) : isCancellationSelected ? (
              <div className="d-flex justify-content-around">
                <button onClick={onClose} className="win-model-btn-tertiary">
                {t("no")}
                </button>
                <button
                  onClick={onOkay}
                  className="win-model-btn-primary"
                >
                  {t("yes")}
                </button>            
              </div>
              ): isPendedStatusSelected ? (
                <button onClick={onOkay} className="win-model-btn-primary">
                  {t("next")}
                </button>
                )
                : showConfirmButtons ? ( 
                  <div className="d-flex justify-content-around">
                    <button onClick={onClose} className="win-model-btn-tertiary">
                    {t("no")}
                    </button>
                    <button onClick={onOkay} className="win-model-btn-primary">
                    {t("yes")}
                    </button>
                  </div>
        ) : isEggFreezing ? (
          <button onClick={onOkay} className="win-model-btn-primary">
            {t("iunderstand")}
          </button>
        ) : onYes && onNo ? (
       
          <div className="d-flex justify-content-around">
             <button onClick={onNo} className="win-model-btn-tertiary">
            {t("no")}
            </button>
             <button onClick={onYes} className="win-model-btn-primary">
            {t("yes")}
            </button>
          </div>  
        ) : (
              <button onClick={onClose} className="win-model-btn-primary">
                {t("ok")}
              </button>

        )}
      </Modal.Body>
    </Modal>
  );
};


export default ErrorModal;
